export default "__VITE_ASSET__BKLv3uOn__"